<template>
  <div id="tax">
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab
          v-for="taxTab in taxTabs"
          :key="taxTab.value"
          :href="`#${taxTab.value}`"
          active-class="v-tab-active-class"
        >
          {{ $t(`views.tax.${taxTab.value}.title`) }}
        </v-tab>
      </v-tabs>
    </v-container>

    <v-container class="tabs-items" fluid tag="section">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item value="taxSummary" :transition="false" :reverse-transition="false">
          <TaxSummary />
        </v-tab-item>
        <v-tab-item value="renta" :transition="false" :reverse-transition="false">
          <Renta />
        </v-tab-item>
        <v-tab-item value="model720" :transition="false" :reverse-transition="false">
          <Model720 />
        </v-tab-item>
        <v-tab-item value="model721" :transition="false" :reverse-transition="false">
          <Model721 />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TaxSummary from '@/views/components/tax/TaxSummary'
import Renta from '@/views/components/tax/Renta'
import Model720 from '@/views/components/tax/Model720'
import Model721 from '@/views/components/tax/Model721'
import gtag from '@/lib/gtag'

const TABS = [
  {
    value: 'taxSummary',
  },
  {
    value: 'renta',
    countryFilter: ['ES'],
    baseCurrencyFilter: ['EUR'],
  },
  {
    value: 'model720',
    countryFilter: ['ES'],
    baseCurrencyFilter: ['EUR'],
  },
  {
    value: 'model721',
    countryFilter: ['ES'],
    baseCurrencyFilter: ['EUR'],
  },
]

export default {
  components: { TaxSummary, Renta, Model720, Model721 },
  data: () => ({
    tab: null,
  }),
  computed: {
    ...mapState(['user']),
    taxTabs() {
      const tabs = []
      for (const tab of TABS) {
        if (
          (!tab.countryFilter || tab.countryFilter.indexOf(this.user.country) > -1) &&
          (!tab.baseCurrencyFilter || tab.baseCurrencyFilter.indexOf(this.user.baseCurrency) > -1)
        ) {
          tabs.push(tab)
        }
      }
      return tabs
    },
  },
  watch: {
    tab() {
      gtag.pageview({
        pagePath: `/tax/${this.tab}`,
        pageTitle: `tax|${this.tab}`,
        pageContentGroup: 'page',
      })
    },
  },
}
</script>
